// import React, { useState } from "react";
// import "./ErrorWindow.css";
// import Draggable from "react-draggable";

// const ErrorWindow = () => {
//   const [isVisible, setIsVisible] = useState(true);

//   const closeError = () => {
//     setIsVisible(false);
//   };

//   return (
//     <>
//       {isVisible && (
//         <div className="error-container">
//           <Draggable>
//             <div className="window">
//               <div className="title-bar">
//                 <div className="title">Windows XP</div>
//                 <button className="close-button" onClick={closeError}>
//                   X
//                 </button>
//               </div>
//               <div className="content">
//                 <p>This is a Windows XP-style window.</p>
//               </div>
//             </div>
//           </Draggable>
//         </div>
//       )}
//     </>
//   );
// };

// export default ErrorWindow;

import React, { useState } from "react";
import "./styles/ErrorWindow.css";
import Draggable from "react-draggable";

const ErrorWindow = ({ onClose, index }) => {
  return (
    <div className="error-container">
      <Draggable>
        <div className="window" style={{ top: 10 * index, right: 10 * index }}>
          <div className="title-bar">
            <div className="title">Windows XP</div>
            <button className="close-button" onClick={onClose}>
              X
            </button>
          </div>
          <div className="content">
            <p>Error Occured!!!</p>
          </div>
        </div>
      </Draggable>
    </div>
  );
};

const App = () => {
  const [windowCount, setWindowCount] = useState(0);

  const openNewWindow = () => {
    setWindowCount(windowCount + 1);
  };

  const handleClose = () => {
    setWindowCount(windowCount - 1);
  };

  return (
    <div>
      <div className="new-window">
        {/* <button onClick={openNewWindow} className="window-button">
          Open New Window
        </button> */}
      </div>
      {Array.from({ length: windowCount }).map((_, index) => (
        <ErrorWindow key={index} index={index} onClose={handleClose} />
      ))}
    </div>
  );
};

export default App;
